import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page';
import { PageNotificationsProvider } from 'app/common/notifications/features/page-notifications/page-notifications.provider';
import { PageNotificationsRender } from 'app/common/notifications/features/page-notifications/page-notifications.render';
import { PageContent } from 'app/ui';

import { TariffPricesGrid } from '../features/tariff-prices-grid/tariff-prices-grid';

export const TariffPricesGridPage = observer(() => {
  return (
    <PageNotificationsProvider>
      <AppPage perm="PERM_TARIFF_READ">
        <PageContent>
          <PageNotificationsRender />
        </PageContent>
        <PageContent>
          <TariffPricesGrid />
        </PageContent>
      </AppPage>
    </PageNotificationsProvider>
  );
});
